<template>
  <div class="page page-inner">
    <breadcrumb title="Detail News"></breadcrumb>
    <div class="row">
      <div class="card-fluid col-sm-12 col-md-7">
        <div class="card-body ">
          <h4 class="font-weight-bold ml-3">{{detail.title}}</h4>
          <p class="text-muted ml-3">
            <em class="fa fa-calendar"></em> {{ formatDate(detail.date, 4) }} <em class="fa fa-tag"></em> {{detail.category_name}}
          </p>
          <div class="col-md-12" style="text-align: justify; width:100%">
            <div v-html="detail.content"></div>
          </div>
          <div class="col-md-12">
            <div class="media mb-0">
              <div class="user-avatar user-avatar-lg mt-0">
                <a  class="" data-toggle="tooltip" :title="detail.emp_name || '' ">
                  <img :src="checkImage(detail.photo_path, detail.photo)" alt="">
                </a>
              </div>
              <div class="media-body">
                <h6 class="font-weight-lighter ml-2 mb-0 mt-1">{{detail.department}}</h6>
                <p class="display-5 text-muted ml-2 mb-1"><span class="mr-2">{{detail.emp_name}}</span></p>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <h5 class="font-weight-bold ml-2">Related Articles</h5>
        <div class="row">
          <div class="col-md-4" v-for="article in articles">
            <div class="media mb-0">
              <div class="mt-0">
                <a @click="toDetailNews(article.id)" style="color:#121212;text-decoration: none" data-toggle="tooltip"
                   :title="article.title">
                  <img class="img-rounded mb-1" :src="article.photo !== null && article.photo !== '' ? urlBackend+'/'+article.photo_path+article.photo : 'assets/images/b432fc7aab82120b441454fe9457a96c.jpg'" width="250px" height="150px" alt="" />
                  <h5 class="font-weight-bold ">{{article.title}}</h5>
                  <p class="text-muted ml-2 mb-1"><em class="fa fa-calendar"></em> {{ formatDate(article.date, 4) }}</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-1"></div>
      <div class="col-sm-12 col-md-3">
        <div class="card card-fluid">
          <div class="card-header nav-scroller">
            <div class="col-md-12 m-2 dt-bootstrap4">
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <h6><em class="fa fa-download"></em> Downloads</h6>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="col-md-12 m-2">
              <h6 v-for="attachment in attachments" @click="downloadFile(attachment, $event)">
                <a class="">
                  <em class="fa fa-file-pdf mr-1"></em> {{attachment.name}}
                </a>

              </h6>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-1"></div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {urlApi} from '../../../../config/url-api'
import AxiosCall from "../../../../libs/AxiosCall";
import FormatDate from "../../../../libs/FormatDate";
export default {
  name: "DetailNews",
  data(){
    return {
      id:"",
      detail :{
        title:"",
        category_name:"",
        date:"",
        emp_name:"",
        department:"",
        photo_path:"",
        tagging:""
      },
      articles:[],
      attachments:[],
      urlBackend:process.env.VUE_APP_URL_BACKEND
    }
  },
  components:{
    Breadcrumb
  },

  methods:{
    toDetailNews(id){
      this.getDetailNews(id)
    },
    getDetailNews(id){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        id: id,
        lang:"en",
        company_id:userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.news.detail).then(res=>{
        if (res.success){
          this.detail = res.atributes[0]
          this.getRelatedArticles()
          this.getAttachmentFile()
        }else{
          this.errorMessage(res.message)
        }
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    formatDate(val, format){
      return FormatDate(val, format)
    },
    checkImage(val, photo){
      return (photo === null || photo === "") ? "assets/images/user-photo.png" : this.urlBackend+val+photo
    },
    getRelatedArticles(){
      let payload = {
        id:this.detail.id
      }

      AxiosCall.Get(payload, urlApi.news.related_articles).then(res=>{
        if(res.success){
          this.articles = res.atributes
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    getAttachmentFile(){
      let payload = {
        id:this.detail.id
      }
      AxiosCall.Get(payload, urlApi.news.list_attachment).then(res=>{
        if(res.success){
          this.attachments = res.atributes
        }else{
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    downloadFile(item, evt){
      evt.preventDefault()
      window.open(this.urlBackend+item.file_path+item.file_name, '_blank');
    }
  },
  created() {

    this.id = atob(this.$route.query.id)
    this.getDetailNews(this.id)
  }
}
</script>

<style scoped>
.img-rounded{
  border-radius: 1rem;
}
</style>